import Alpine from "alpinejs";
import ToastComponent from "../../vendor/usernotnull/tall-toasts/dist/js/tall-toasts";
require("./bootstrap");
require("./custom");
const sentryScript = document.createElement('script');
sentryScript.src = 'https://js.sentry-cdn.com/0e776ff130dde60fca84d77af5532168.min.js';
sentryScript.crossOrigin = 'anonymous';
document.head.appendChild(sentryScript);

sentryScript.onload = function () {
    Sentry.init({
        dsn: "https://0e776ff130dde60fca84d77af5532168@o4505243997634560.ingest.sentry.io/4505764219453440",
        maxBreadcrumbs: 50,
        debug: true,
    });

    // const originalConsoleError = console.error;

//     console.error = function (...args) {
//         // Call the original console.error method
//         originalConsoleError.apply(console, args);
//
//         // Send the error to Sentry
//         Sentry.captureException(args[0]); // Assuming the first argument is the error object
//     };
//
//     console.log = function (...args) {
//         // Call the original console.error method
//         originalConsoleError.apply(console, args);
//
//         // Send the error to Sentry
//         Sentry.captureException(args[0]); // Assuming the first argument is the error object
//     };
//
//     console.warn = function (...args) {
//         // Call the original console.error method
//         originalConsoleError.apply(console, args);
//
//         // Send the error to Sentry
//         Sentry.captureException(args[0]); // Assuming the first argument is the error object
//     };
};

import Tribute from "tributejs";
import Croppr from "croppr";
import select2 from "select2";

window.Tribute = Tribute;
window.select2 = select2;
window.Croppr = Croppr;
Alpine.data("ToastComponent", ToastComponent);

window.Alpine = Alpine;
Alpine.start();

//
// // Import the components
// import { createApp } from 'vue';
// import Comments from './components/Comments.vue';
// import Comment from './components/Comment.vue';
// import Board from './components/Board.vue';
// import BuyAsset from './components/BuyAsset.vue';
// import Asset from './components/Asset.vue';
// import DownloadAsset from './components/DownloadAsset.vue';
// import CollectionVue from './components/CollectionVue.vue';
// import MasonryVue from './components/MasonryVue.vue';
// import ButtonSecondary from './components/ButtonSecondaryVue.vue';
// import BuyCollectionVue from './components/BuyCollectionVue.vue';
// import DownloadCollection from './components/DownloadCollection.vue';
// import HomepageVue from './components/HomepageVue.vue';
// import SingleCollectionPreview from './components/SingleCollectionPreview.vue';
// import Thumbnail from './components/Thumbnail.vue';
// import Collage from './components/Collage.vue';
// import Collage1 from './components/Collage1.vue';
// import Collage2 from './components/Collage2.vue';
// import Collage3 from './components/Collage3.vue';
// import Swiper from './components/Swiper';
//
//
// import mitt from 'mitt';
// const eventBus = mitt();
// window.globalEventBus = eventBus;
//
// const app = createApp({});
// app.config.devtools = true;
// app.component('homepage-vue', HomepageVue)
// app.component('single-collection-preview', SingleCollectionPreview)
// app.component('thumbnail', Thumbnail)
// app.component('collage', Collage)
// app.component('collage1', Collage1)
// app.component('collage2', Collage2)
// app.component('collage3', Collage3)
// app.component('masonry-vue', MasonryVue)
// app.component('btn-secondary', ButtonSecondary)
// app.component('asset', Asset)
// app.component('buy-asset', BuyAsset)
// app.component('download-asset', DownloadAsset)
// app.component('board', Board)
// app.component('comments', Comments);
// app.component('comment', Comment);
// app.component('mySwiper', Swiper);
// app.mount('#homepageVue')
//
// const app2 = createApp({});
// app2.config.devtools = true;
// app2.component('collection-vue', CollectionVue)
// app2.component('masonry-vue', MasonryVue)
// app2.component('asset', Asset)
// app2.component('btn-secondary', ButtonSecondary)
// app2.component('buy-asset', BuyAsset)
// app2.component('download-asset', DownloadAsset)
// app2.component('board', Board)
// app2.component('comments', Comments);
// app2.component('comment', Comment);
// app2.component('buy-collection-vue', BuyCollectionVue);
// app2.component('download-collection', DownloadCollection)
// app2.mount('#collectionVue')
// // Register the components
// // app.component('asset-viewer', AssetViewer);
// // app.component('comments', Comments);
// // app.component('comment', Comment);
// // app.component('board', Board);
// // app.component('vue-dialog', VueDialog);
// // app.component('buy-asset', BuyAsset);
// // app.component('asset', Asset);
// // app.component('download-asset', DownloadAsset);
// // app.component('collection-vue', CollectionVue);
// // // Mount the app to the DOM
// // app.mount('#app');
//
// import AssetsPage from './components/AssetsPage.vue';
//
// const app3 = createApp({});
// app3.config.devtools = true;
// app3.component('assets-page', AssetsPage);
// app3.component('masonry-vue', MasonryVue)
// app3.component('asset', Asset)
// app3.component('btn-secondary', ButtonSecondary)
// app3.component('buy-asset', BuyAsset)
// app3.component('download-asset', DownloadAsset)
// app3.component('board', Board)
// app3.component('comments', Comments);
// app3.component('comment', Comment);
// app3.mount('#assetsPage');
//
// import FavoriteAssetsPage from './components/FavoriteAssetsPage.vue';
//
// const app4 = createApp({});
// app4.config.devtools = true;
// app4.component('favorite-assets-page', FavoriteAssetsPage);
// app4.component('assets-page', AssetsPage);
// app4.component('masonry-vue', MasonryVue)
// app4.component('asset', Asset)
// app4.component('btn-secondary', ButtonSecondary)
// app4.component('buy-asset', BuyAsset)
// app4.component('download-asset', DownloadAsset)
// app4.component('board', Board)
// app4.component('comments', Comments);
// app4.component('comment', Comment);
// app4.mount('#favoriteAssetsPage');
